import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { App } from "./App";
import { ThemeProvider } from "@/components/ThemeProvider";
import { installMocks, MOCKS_ENABLED } from "@/mocks";
import "./index.css";

// With VITE_USE_MOCKS=1 the console runs against an in-memory fleet, so the UI
// is reviewable before the server exists. Installed before the first render so
// no real request escapes.
if (MOCKS_ENABLED) installMocks();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      // One retry: a transport blip is worth retrying, a 4xx is not, and the
      // per-query hooks override this where it matters.
      retry: 1,
      staleTime: 10_000,
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </ThemeProvider>
  </React.StrictMode>,
);
